import React from 'react';
import { coachesDefault, defaultAvatar } from '../constants/constants';
import Cards from '../common/Cards';

export interface CoachInfo {
  avatar_url?: string;
  more_experts: string[];
  name: string;
}

interface coachesAndNotes {
  coachInfo: CoachInfo;
  note: string;
}

interface NotesFromCoachProps {
  coachesAndNotes: coachesAndNotes;
  teacherUuid?: string;
  isPdfMode?: boolean;
}

const NotesFromCoach: React.FC<NotesFromCoachProps> = ({
  coachesAndNotes,
  teacherUuid,
  isPdfMode
}) => {
  const { more_experts, avatar_url, name } = coachesAndNotes?.coachInfo;

  return (
    <>
      <section id="notes-from-coach" data-pdf-section>
        <Cards border="#E8D8F9" bg="#FBF7FF" p="py-25px">
          <p
            className={`px-[25px] text-[#927FA5] text-[12.5px] font-[550] leading-[normal] mb-[5px]`}
          >
            A note from your teacher:
          </p>
          <p className="px-[25px] text-[#3C0074] text-[13.5px] md:text-[14.5px] font-medium leading-[normal]">
            {coachesAndNotes.note}
          </p>
          {(name || '') && (avatar_url || defaultAvatar) ? (
            <div className="px-[25px] flex items-center gap-[12px] mt-[15px]">
              <img
                width="38"
                height="38"
                src={avatar_url || defaultAvatar}
                className="rounded-full w-[38px] h-[38px] object-cover shrink-0"
                alt="coach-avatar"
              />
              <div className="flex flex-col">
                <div className="text-[#3C0074] text-[14px] font-medium leading-[normal]">
                  {name || ''}
                </div>
                <p
                  {...(isPdfMode && teacherUuid
                    ? { 'data-pdf-teacher-link': true, 'data-teacher-uuid': teacherUuid }
                    : {})}
                  className="text-[#B7A1CC] text-[12px] font-[550] leading-[normal] underline m-0"
                >
                  Drop {name} a Message
                </p>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className="h-[1px] bg-[#ECDFF9] mt-[20px]" />
          <div className="flex flex-col md:flex-row items-center justify-start px-[25px] pt-[10px] pb-[10px] gap-[10px] md:gap-[15px]">
            <div className="shrink-0 relative flex items-center justify-start w-[98px] h-[32px]">
              {(more_experts || coachesDefault).map((coach, index) => {
                return (
                  <img
                    key={index}
                    className={`absolute rounded-full border-[2px] border-[#FBF7FF] w-[32px] h-[32px] object-cover shrink-0`}
                    style={{
                      left: `${index * 22}px`,
                      zIndex: (more_experts || coachesDefault).length - index
                    }}
                    width="32"
                    height="32"
                    src={coach}
                    alt="coach-avatar"
                  />
                );
              })}
            </div>
            <p className="w-full md:w-[unset] text-left text-[12.5px] font-[550] leading-[20px] text-[#927FA5]">
              In addition to {name || ''} we have 150+ more expert teachers available on the
              platform
            </p>
          </div>
        </Cards>
      </section>
    </>
  );
};

export default NotesFromCoach;
